// extracted by mini-css-extract-plugin
module.exports = {"g1ax9l20":"g1ax9l20"};